module.exports = __webpack_public_path__ + "static/hero-border-green-9bca863217b559b79e865d3576f25a34.svg";